{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Rozšíření Chrome není nainstalováno.",
      "CTA": "Nainstalovat rozšíření"
    },
    "STATUS": {
      "OFFLINE": "Telefon odpojen",
      "IN_OTHER_TAB": "Telefon připojen v jiné záložce",
      "CONNECTING": "Připojuji se...",
      "DISCONNECTING": "Odpojuji se...",
      "ONLINE": "Telefon připojen",
      "DIALING": "Vytáčím",
      "TRANSFERRING": "Přepojuji...",
      "CONSULTING": "Hovor s kolegou",
      "CALLER_ON_HOLD": "Volající čeká na lince",
      "BUSY": "Obsazeno",
      "DND": "DND",
      "UNAVAILABLE": "Nedostupný",
      "REJECTED": "Hovor zamítnut",
      "CALL_FAILED": "Hovor selhal"
    },
    "QUEUES": {
      "MORE": "Další fronty"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Historie"
    },
    "HISTORY": {
      "OPEN": "Otevřené",
      "RECENT": "Nedávné",
      "MISSED": "Zmeškané",
      "LOADING": "Načítám hovory...",
      "EMPTY": "Žádné hovory",
      "ERROR": "Hovory se nepodařilo načíst",
      "CALL": "Zavolat zpět",
      "CALL_STATUS": {
        "BUTTON": "Nastavit stav hovoru",
        "TITLE": "Stav hovoru",
        "SEARCH_PLACEHOLDER": "Hledat stavy...",
        "LOADING": "Načítám stavy...",
        "NO_OPTIONS": "Nejsou nastavené žádné stavy hovoru",
        "NO_MATCH": "Žádný stav neodpovídá",
        "OPTIONS_ERROR": "Stavy se nepodařilo načíst",
        "RETRY": "Zkusit znovu",
        "CONFIRM_QUESTION": "Nastavit „{status}“ a vyřešit konverzaci?",
        "CONFIRM": "Potvrdit",
        "BACK": "Zpět",
        "CANCEL": "Zrušit",
        "SAVING": "Ukládám...",
        "SAVE_ERROR": "Stav se nepodařilo uložit",
        "RESOLVE_ERROR": "Stav byl uložen, ale konverzaci se nepodařilo vyřešit"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonní číslo, např. +421903000000",
      "BODY_PLACEHOLDER": "Napište zprávu...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Odeslat SMS",
      "SENDING": "Odesílám...",
      "SENT": "SMS odeslána",
      "LOADING": "Načítám SMS schránky...",
      "NO_INBOX": "Tento účet nemá SMS schránku, SMS nelze odeslat.",
      "INVALID_NUMBER": "Zadejte číslo v mezinárodním formátu včetně úvodního +.",
      "ERROR": "SMS se nepodařilo odeslat. Zkuste to prosím znovu."
    },
    "ACTIONS": {
      "CONNECT": "Přihlásit",
      "GO_TO_TAB": "Přejít na záložku",
      "DISCONNECT": "Odhlásit",
      "ANSWER": "Přijmout",
      "HANGUP": "Položit",
      "HOLD": "Přidržet",
      "MUTE": "Vypnout mikrofon",
      "SILENCE": "Ztlumit",
      "TRANSFER": "Přepojit",
      "COMPLETE_TRANSFER": "Dokončit přepojení",
      "RETURN_TO_CALLER": "Zpět k volajícímu",
      "CANCEL_TRANSFER": "Zrušit přepojení",
      "DIALPAD": "Zobrazit číselník",
      "OPEN_CONVERSATION": "Otevřít konverzaci"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Příchozí hovor",
      "INCOMING_CALL_FROM": "Příchozí hovor od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Příchozí hovor od {number}",
      "ANSWER": "Přijmout",
      "DECLINE": "Odmítnout"
    },
    "TRANSFER": {
      "TITLE": "Přepojit hovor",
      "PLACEHOLDER": "Zadejte číslo pro přepojení...",
      "SEARCH_PLACEHOLDER": "Hledat agenty...",
      "TARGET_PLACEHOLDER": "Vybraný cíl přepojení",
      "CONFIRM": "Přepojit",
      "MODE_DIRECT": "Přepojit rovnou",
      "MODE_CONSULT": "Nejdřív zavolat kolegovi",
      "CANCEL": "Zrušit"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Opravdu chcete jít na pauzu ze všech front?",
      "CONFIRM_READY": "Opravdu se chcete vrátit do stavu připraven ve všech frontách?",
      "CONFIRM_BREAK_QUEUE": "Opravdu se chcete odhlásit z fronty {queue}?",
      "CONFIRM_READY_QUEUE": "Opravdu se chcete přihlásit do fronty {queue}?",
      "LOGIN_TO_QUEUE": "Přihlásit",
      "LOGOUT_FROM_QUEUE": "Odhlásit",
      "LOGIN_TO_ALL_QUEUES": "Přihlásit do všech front",
      "LOGOUT_FROM_ALL_QUEUES": "Odhlásit ze všech front",
      "OPTION_LOGOUT": "Odhlásit",
      "OPTION_BREAK": "Pauza",
      "OPTION_LUNCH": "Oběd",
      "OPTION_AWAY": "Nepřítomen",
      "OPTION_DO_NOT_DISTURB": "Nerušit",
      "OPTION_BUSINESS_TRIP": "Služební cesta",
      "CONFIRM": "Potvrdit",
      "CANCEL": "Zrušit"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Telefon se nepodařilo připojit",
      "MESSAGE": "Zdá se, že vaše internetové připojení nefunguje. Zkontrolujte ho prosím a zkuste to znovu.",
      "CREDENTIALS_TITLE": "Telefonní ústředna odmítla vaše přihlašovací údaje",
      "CREDENTIALS_MESSAGE": "Ústředna nepřijala uživatelské jméno nebo heslo uložené ve vašem profilu. Zkontrolujte je v nastavení profilu, nebo se obraťte na správce.",
      "CONFIGURATION_TITLE": "Nastavení telefonu není platné",
      "CONFIGURATION_MESSAGE": "Uživatelské jméno SIP nebo adresa serveru nemají platný formát, takže se telefon nemůže připojit. Opravte je v nastavení profilu.",
      "NETWORK_SHORT": "Připojení se nezdařilo",
      "CREDENTIALS_SHORT": "Údaje odmítnuty",
      "CONFIGURATION_SHORT": "Neplatné nastavení telefonu",
      "RETRY": "Zkusit znovu",
      "DISMISS": "Zrušit"
    },
    "CONNECTION_QUALITY": "Kvalita připojení",
    "CONNECTION_QUALITY_EXCELLENT": "Skvělá",
    "CONNECTION_QUALITY_GOOD": "Dobrá",
    "CONNECTION_QUALITY_FAIR": "Průměrná",
    "CONNECTION_QUALITY_POOR": "Špatná",
    "CONNECTION_QUALITY_DISCONNECTED": "Odpojeno"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Vytáčím {number}… Můžete zavřít tuto záložku.",
    "NO_NUMBER": "Nebylo zadáno číslo. Použijte ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Zadejte telefonní číslo...",
    "ACTIONS": {
      "DIAL": "Vytočit číslo",
      "DIAL_FROM": "Zvolit číslo, ze kterého volám"
    },
    "DIAL_FROM": {
      "TITLE": "Volat z čísla schránky"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonní číslo je povinné",
      "INVALID_FORMAT": "Neplatný formát telefonního čísla"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Nastavení a testování zvuku",
    "SELECT_DEVICE": "Vyberte zařízení...",
    "SYSTEM_DEFAULT": "Systémové výchozí",
    "SAVED": "Uloženo",
    "DISCONNECTED_SUFFIX": "nepřipojeno",
    "DEVICE_DISCONNECTED": "Vybrané zařízení není připojené. Hovory použijí systémové výchozí, dokud se nevrátí.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Testovat mikrofon",
      "STOP_TEST": "Ukončit test",
      "LEVEL": "Hlasitost:",
      "VERDICT": {
        "LISTENING": "Řekněte něco do mikrofonu…",
        "SILENT": "Není vás slyšet. Zkontrolujte, že je mikrofon zapnutý a vybraný ten správný.",
        "LOW": "Je vás slyšet jen potichu. Vyberte jiný mikrofon nebo upravte vstupní hlasitost v nastavení systému.",
        "GOOD": "Dobrý zvuk — je vás dobře slyšet."
      }
    },
    "SPEAKER": {
      "TITLE": "Reproduktor",
      "TEST": "Testovat reproduktor",
      "TESTING": "Testuji...",
      "VOLUME": "Hlasitost:",
      "USING_DEFAULT": "Vybraný výstup není dostupný — přehráno přes systémové výchozí zařízení."
    },
    "DONE": "Hotovo",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Chyba při přístupu k mikrofonu. Zkontrolujte oprávnění.",
      "MICROPHONE_PERMISSION_DENIED": "Přístup k mikrofonu je blokován. Povolte jej v nastavení webu prohlížeče, abyste mohli telefonovat.",
      "MICROPHONE_SILENT": "Váš mikrofon nezachycuje žádný zvuk. Zkontrolujte nastavení zvuku.",
      "EXTENSION_REQUIRED": "Telefonní rozšíření nebylo nalezeno. Nainstalujte nebo povolte je, abyste mohli používat mikrofon.",
      "SPEAKER_TEST": "Chyba při testování reproduktoru."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Obsazeno"
  },
  "QUEUE_STATUS": {
    "READY": "Připraven",
    "NOT_READY": "Nepřijímá hovory",
    "WRAP_UP": "Dokončuje hovor",
    "BREAK": "Pauza",
    "LUNCH": "Oběd",
    "AWAY": "Nepřítomen",
    "DO_NOT_DISTURB": "Nerušit",
    "BUSINESS_TRIP": "Služební cesta",
    "OTHER_CALL": "Jiný hovor",
    "QUEUE_CALL": "Hovor z fronty",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Bez telefonu",
    "PARTIALLY_READY": "Částečně připraven",
    "MIXED": "Smíšený stav",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Zaneprázdněn (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
